/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { format, Heading } from '@msdyn365-commerce-modules/utilities';
import { RichTextComponent } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import { IFamilyAndFriendsViewProps } from './family-and-friends';

export default (props: IFamilyAndFriendsViewProps) => {
    if (props.data.codeList.result?.Result.Codes?.length === 0) { return <div />; } // don't show if no codes
    return (
        <div className={classnames('family-friends', props.config.className)}>
            {props.config.heading &&
                <Heading
                    className='family-friends__heading'
                    headingTag={props.config.heading.tag}
                    text={props.config.heading.text}
                />
            }
            <div className='family-friends__remaining'>
                {
                    format(
                        props.resources.familyFriends_codesRemaining,
                        props.data.codeList.result?.Result.QuantityAvailable || 0
                    )
                }
            </div>
            <div className='family-friends__table'>
                {props.header}
                {props.codes}
            </div>
            <RichTextComponent className='family-friends__message' text={props.config.helpText || ''} />
        </div>
    );
};
